import { defineMessages } from "react-intl";
import { ArticleType } from "@shared/url";

export const articleTypes = defineMessages<ArticleType>({
  [ArticleType.RENTAL]: { id: "generic.article-type.rental", defaultMessage: "Locations de courte durée" },
  [ArticleType.SEASONAL]: { id: "generic.article-type.seasonal", defaultMessage: "Locations de saison" },
  [ArticleType.ANNUAL]: { id: "generic.article-type.annual", defaultMessage: "Locations à l'année" },
  [ArticleType.SALE]: { id: "generic.article-type.sale", defaultMessage: "Vente" },

});

export const common = defineMessages({
  countedGuests: { id: "generic.common.counted-guests", defaultMessage: "{count, plural, =1 {# personne} other {# personnes}}" },
  limitedGuests: { id: "generic.common.limited-guests", defaultMessage: "{format, select, single {{count} personne} max {{max}+ personnes} other {{count} personnes}}" }
});

export const pricing = defineMessages({
  price: { id: "generic.prices.price", defaultMessage: "Prix" },
  unit: { id: "generic.prices.unit", defaultMessage: "Prix unitaire" },
  amount: { id: "generic.prices.amount", defaultMessage: "Montant" },
  discount: { id: "generic.prices.discount", defaultMessage: "Réduction" },
  total: { id: "generic.prices.total", defaultMessage: "Total" },
  detailed: { id: "generic.prices.detailed", defaultMessage: "Détail du prix" },
  onDemand: { id: "generic.prices.on-demand", defaultMessage: "Prix sur demande" },
  onDemandShort: { id: "generic.prices.on-demand-short", defaultMessage: "Sur demande" },
  lowest: { id: "generic.prices.lowest", defaultMessage: "Dès {price} par {type, select, DAILY {nuit} other {semaine}}"},
  byNight: { id: "generic.prices.by-night", defaultMessage: "{price} par nuitée" },
  byWeek: { id: "generic.prices.by-week", defaultMessage: "Dès {price} par semaine" },
  byMonth: { id: "generic.prices.by-month", defaultMessage: "{price} par mois" },
  down: { id: "generic.prices.down-payment", defaultMessage: "Acompte" },
  chargeLabel: { id: "generic.prices.charge-label", defaultMessage: "Frais de service" },
  charge: { id: "generic.prices.charge", defaultMessage: "{adaptive, select, true {jusqu'à } other {}}{amount}" },
  taxes: { id: "generic.prices.taxes", defaultMessage: "Taxes de séjour" }
});

export const booking = defineMessages({
  checkIn: { id: "generic.booking.check-in", defaultMessage: "Arrivée" },
  checkOut: { id: "generic.booking.check-out", defaultMessage: "Départ" },
  period: { id: "generic.booking.period", defaultMessage: "Période" },
  nights: { id: "generic.booking.nights", defaultMessage: "{count, plural, =1 {une nuit} other {# nuits}}" },
});

export const actions = defineMessages({
  yes: { id: "generic.actions.yes", defaultMessage: "Oui" },
  no: { id: "generic.actions.no", defaultMessage: "Non" },
  login: { id: "generic.actions.login", defaultMessage: "Se connecter" },
  logout: { id: "generic.actions.logout", defaultMessage: "Se déconnecter" },
  register: { id: "generic.actions.register", defaultMessage: "S'inscrire" },
  refresh: { id: "generic.actions.refresh", defaultMessage: "Rafraîchir" },
  remove: { id: "generic.actions.remove", defaultMessage: "Supprimer" },
  continue: { id: "generic.actions.continue", defaultMessage: "Continuer" },
  back: { id: "generic.actions.back", defaultMessage: "Retour" },
  backHome: { id: "generic.actions.back-home", defaultMessage: "Retour à la page d'accueil" },
  send: { id: "generic.actions.send", defaultMessage: "Envoyer" },
  contact: { id: "generic.actions.contact", defaultMessage: "Contacter" },
  book: { id: "generic.actions.book", defaultMessage: "Réserver" },
  close: { id: "generic.actions.close", defaultMessage: "Fermer" },
  validate: { id: "generic.actions.validate", defaultMessage: "Valider" },
  save: { id: "generic.actions.save", defaultMessage: "Enregistrer" },
  showMap: { id: "generic.actions.map-show", defaultMessage: "Voir la carte" },
  showList: { id: "generic.actions.list-show", defaultMessage: "Voir la liste" },
  callUs: { id: "generic.actions.call-us", defaultMessage: "Appelez-nous" },
  search: { id: "generic.actions.search", defaultMessage: "Rechercher" },
  reset: { id: "generic.actions.reset", defaultMessage: "Réinitialiser" }
});

export const form = defineMessages({
  firstName: { id: "generic.form.firstName", defaultMessage: "Prénom" },
  lastName: { id: "generic.form.lastName", defaultMessage: "Nom" },
  email: { id: "generic.form.email", defaultMessage: "E-mail" },
  phone: { id: "generic.form.phone", defaultMessage: "Téléphone" },
  street: { id: "generic.form.street", defaultMessage: "Rue" },
  address: { id: "generic.form.address", defaultMessage: "Adresse" },
  booking: { id: "generic.form.booking", defaultMessage: "Réservation" },
  inResort: { id: "generic.form.inResort", defaultMessage: "Agence" },
  streetNumber: { id: "generic.form.streetNumber", defaultMessage: "N°" },
  streetComplement: { id: "generic.form.streetComplement", defaultMessage: "Adresse complémentaire" },
  zip: { id: "generic.form.zip", defaultMessage: "NPA" },
  city: { id: "generic.form.city", defaultMessage: "Localité" },
  country: { id: "generic.form.country", defaultMessage: "Pays" },
  countryPlaceholder: { id: "generic.form.country-placeholder", defaultMessage: "Sélectionnez un pays" },
  msg: { id: "generic.form.msg", defaultMessage: "Message" },
  msgPlaceholder: { id: "generic.form.msg-placeholder", defaultMessage: "Dites-nous comment nous pouvons vous aider." },
  datePlaceholder: { id: "generic.form.date-placeholder", defaultMessage: "Ajouter des dates" },
  guests: { id: "generic.form.guests", defaultMessage: "Participants" },
  guestsPlaceholder: { id: "generic.form.guests-placeholder", defaultMessage: "Ajouter des participants" },
  emptyError: { id: "generic.form.errors.empty", defaultMessage: "Cette information est requise" },
  emailError: { id: "generic.form.errors.email", defaultMessage: "Cet e-mail n'est pas valide" },
  phoneError: { id: "generic.form.errors.phone", defaultMessage: "Ce numéro n'est pas valide. Respectez le format international (+41 xx xxx xx xx)" },
  minError: { id: "generic.form.errors.min", defaultMessage: "Doit contenir au moins {min} caractères" },
  sent: { id: "generic.form.sent", defaultMessage: "Votre message a été envoyé avec succès" },
  failed: { id: "generic.form.failed", defaultMessage: "Une erreur est survenue à l'envoi" }
});

export const routes = defineMessages({
  useful_info: { id: "generic.routes.usefulinfo", defaultMessage: "Info utile" },
  contact: { id: "generic.routes.contact", defaultMessage: "Contact" },
  conditions: { id: "generic.routes.conditions", defaultMessage: "Conditions générales" },
  notice: { id: "generic.routes.notice", defaultMessage: "Mention légale" }
});

export const article = defineMessages({
  surface: { id: "generic.article.surface", defaultMessage: "Surface" },
  rooms: { id: "generic.article.rooms", defaultMessage: "Pièces" },
  roomRooms: { id: "generic.article.rooms-whole", defaultMessage: "Ensemble" },
  bedrooms: { id: "generic.article.bedrooms", defaultMessage: "Chambres" },
  bathrooms: { id: "generic.article.bathrooms", defaultMessage: "Salles de bains" },
  equipment: { id: "generic.article.equipment", defaultMessage: "Équipements" },
  cityCenter: { id: "generic.article.features.city-center", defaultMessage: "Proche du centre" },
  shoppingArea: { id: "generic.article.features.shopping-area", defaultMessage: "Sur rue commerçante" },
  skiArea: { id: "generic.article.features.ski-area", defaultMessage: "À proximité des remontées" },
  busStop: { id: "generic.article.features.bus-stop", defaultMessage: "Proche des transports en commun" },
  clearView: { id: "generic.article.features.clear-view", defaultMessage: "Vue dégagée" },
  parking: { id: "generic.article.features.parking", defaultMessage: "Parking" },
  lift: { id: "generic.article.features.lift", defaultMessage: "Ascenseur" },
  balcony: { id: "generic.article.features.balcony", defaultMessage: "Balcon" },
  terrace: { id: "generic.article.features.terrace", defaultMessage: "Terrasse" },
  pool: { id: "generic.article.features.pool", defaultMessage: "Piscine" },
  sauna: { id: "generic.article.features.sauna", defaultMessage: "Sauna" },
  fireplace: { id: "generic.article.features.fireplace", defaultMessage: "Cheminée" },
  dishwasher: { id: "generic.article.features.dishwasher", defaultMessage: "Lave-vaisselle" },
  washingMachine: { id: "generic.article.features.washing-machine", defaultMessage: "Lave-linge" },
  tv: { id: "generic.article.features.tv", defaultMessage: "TV" },
  wifi: { id: "generic.article.features.wifi", defaultMessage: "WIFI" },
  microwave: { id: "generic.article.features.microwave", defaultMessage: "Micro-onde" },
  oven: { id: "generic.article.features.oven", defaultMessage: "Four" },
  smoker: { id: "generic.article.features.smoker", defaultMessage: "Non-fumeur" },
  pet: { id: "generic.article.features.pet", defaultMessage: "Animaux admis" },
  disabledPerson: { id: "generic.article.features.disabled-person", defaultMessage: "Accès pour personnes handicapées" },
  new: { id: "generic.article.features.new", defaultMessage: "Neuf" },
  furnished: { id: "generic.article.features.furnished", defaultMessage: "Meublé" },
  secondaryHome: { id: "generic.article.features.secondary-home", defaultMessage: "Résidence secondaire" },
  forForeigners: { id: "generic.article.features.for-foreigners", defaultMessage: "Disponible aux non-résidents" },
  orientation: { id: "generic.equipment.orientation", defaultMessage: "Orientation"},
  year: { id: "generic.equipment.year", defaultMessage: "Année" },
  bedroom: { id: "generic.equipment.bedroom", defaultMessage: "Chambre" },
  bedrooms_plural: { id: "generic.equipment.bedrooms", defaultMessage: "{count, plural, =1 {# Chambre} other {# Chambres}}" },
  bathroom: { id: "generic.equipment.bathroom", defaultMessage: "Salle de bain" },
  bathrooms_plural: { id: "generic.equipment.bathrooms", defaultMessage: "{count, plural, =1 {# Salle de bain} other {# Salle de bains}}" },
  maxGuest: { id: "generic.equipment.maxGuest", defaultMessage: "{count, plural, =1 {# Personne} other {# Personnes}}" },
  floor: { id: "generic.equipment.floor", defaultMessage: "Étage" },
  heating: { id: "generic.equipment.heating", defaultMessage: "Chauffage" },
  annual_charges: { id: "generic.equipment.annual-charges", defaultMessage: "Charges annuelles" },
  renovation_fund: { id: "generic.equipment.renovation-fund", defaultMessage: "Fond de rénovation" },
  no_pet: { id: "generic.equipment.no-pet", defaultMessage: "Animaux non admis" },
  elevator: { id: "generic.equipment.elevator", defaultMessage: "Ascenseur" },
  no_smoker: { id: "generic.equipment.no-smoker", defaultMessage: "Non fumeur" },
  hairdryer: { id: "generic.equipment.hairdryer", defaultMessage: "Sèche cheveux" },
  cheese_set: { id: "generic.equipment.cheese-set", defaultMessage: "Set de raclette ou/et fondue" },
  clothes_washer: { id: "generic.equipment.clothes-washer", defaultMessage: "Lave linge / séche linge" },
  nearShoppingArea: { id: "generic.equipment.nearShoppingArea", defaultMessage: "À proximité des supermarchés" },
  nearSkiArea: { id: "generic.equipment.nearSkiArea", defaultMessage: "A proximité des remontées mécaniques" },
  nearBusStation: { id: "generic.equipment.nearBusStation", defaultMessage: "Arrêt de bus à proximité" }
});
